import { render, staticRenderFns } from "./AnswerTypeRanking.vue?vue&type=template&id=67997c5c&scoped=true"
import script from "./AnswerTypeRanking.vue?vue&type=script&lang=js"
export * from "./AnswerTypeRanking.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeRanking.vue?vue&type=style&index=0&id=67997c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67997c5c",
  null
  
)

export default component.exports